import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PagerService } from '../../services/index';
import * as $ from 'jquery';

@Component({
	selector: 'app-transaction-report',
	templateUrl: './transaction-report.component.html',
	styleUrls: ['./transaction-report.component.css']
})
export class TransactionReportComponent implements OnInit {
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: number=10;
	pageNo: any = 1;
	time: any = 0;
	transactionReport: any[];
	isReportAvailable: boolean = true;
	reportDate: any;
	redirectUrl: any;
	activePageNo: any = 0;
	appPurchaseArr:any=[];
	constructor(private router: Router, private activatedRoute: ActivatedRoute, private pagerService: PagerService, private authService: AuthService,
		private commonService: CommonService) { }

	ngOnInit() {
		this.time=1;
		this.commonService.process();
		$('.navbar-brand').text('Daily Transactions Report');
		// let route = this.router.url;
		// if(route.indexOf("?backUrl") !== -1){
		// 	var routeArr = route.split('?backUrl=');
		// 	var decodedUri = decodeURIComponent(routeArr[1]);
		// 	var decodedArr = decodedUri.split("&");
		// 	var decodedPageNo =  decodedArr[0].split("pageNo=");
		// 	var decodedTime =  decodedArr[1].split("time=");
		// 	this.pageNo = decodedPageNo[1];
		// 	this.activePageNo = decodedPageNo[1];
		// 	this.time = decodedTime[1];
		// 	$('#selectReport').val(this.time);
		// }
		this.getTransactionReport(this.pageNo, this.limit, this.time);
		this.appPurchaseArr = {
			"country_post_survey_amount": "Country Post Survey",
			"country_post_top_survey_amount": "Country Post & Top Survey",
			"country_post_yearly_survey_amount": "Country Post & Yearly Survey",
			"country_post_yearly_top_survey_amount": "Country Post, Yearly & Top Survey",
			"country_top_survey_amount": "Country Top Survey",
			"country_yearly_survey_amount": "Country Yearly Survey",
			"country_yearly_top_survey_amount": "Country Yearly & Top Survey Amount",
			"world_post_survey_amount": "World Post Survey",
			"world_post_top_survey_amount": "World Post & Top Survey",
			"world_post_yearly_survey_amount": "World Post & Yearly Survey",
			"world_post_yearly_top_survey_amount": "World Post, Yearly & Top Survey",
			"world_top_survey_amount": "World Top Survey",
			"world_yearly_survey_amount": "World Yearly Survey",
			"world_yearly_top_survey_amount":"World Yealy & Top Survey" 
		};
	}

	

	// Get transaction report
	getTransactionReport = function (pageNo, limit, time) {
		this.commonService.process();
		this.authService.getTransactionReport(pageNo, limit, time).subscribe(data=>{
			if(data.success){
				var that = this;
				//if(pageNo == this.activePageNo)
				// setTimeout(function(){ 
				// 	$('#page_'+that.activePageNo).addClass('active');
				// 	if(that.activePageNo == 1)
				// 		$('#first, #prev').addClass('disabled');
				// 	else if(that.activePageNo == that.pager.totalPages)
				// 		$('#next, #last').addClass('disabled');
				// },100);
				this.isReportAvailable = true;
				this.transactionReport = data.transactions;
				this.total = data.total;
				this.pageNo = pageNo;
				this.setPage(pageNo, true);
				this.redirectUrl = "pageNo="+pageNo+"&time="+time+"&type=3";
			}
			else{
				this.isReportAvailable = false;
				this.transactionReport = [];
			}
			this.getReportDate(time);
			this.changeTitle(time);
			this.commonService.hideProcess();
		});
	}

	

	// Search Report
	searchReport = function(time){
		this.time = time;
		this.getTransactionReport(1, this.limit, time);
	}

	// Pagination
	setPage(page: number, param) {
		// $('.pages.active a').each(function(){
		// 	if(parseInt($(this).text()) != page)
		// 		$(this).parent('li').removeClass('active');
		// });
		// if($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
		// 	$('#first, #prev').removeClass('disabled');
		// if($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
		// 	$('#next, #last').removeClass('disabled');
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.transactionReport.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getTransactionReport(page, this.limit, this.time);
		}
	}

	// Change title
	changeTitle = function(time){
		if(time=='1'){
			$(".navbar-brand").text("Daily Transactions Report");
		}
		else if(time=='2'){
			$(".navbar-brand").text("Weekly Transactions Report");
		}
		else if(time=='3'){
			$(".navbar-brand").text("Monthly Transactions Report");
		}	
		else{
			$(".navbar-brand").text("Yearly Transactions Report");
		}
	}

	// Get current Date
	getReportDate = function (time) {
		var month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		var MyDate = new Date();
		var toDateString = ('0' + MyDate.getDate()).slice(-2) + '-'
			+ month_names_short[MyDate.getMonth()] + '-'
			+ MyDate.getFullYear();

		var newDate = MyDate;
		if (time === "2")
			newDate.setDate(newDate.getDate() - 7);
		if (time === "3")
			newDate.setMonth(newDate.getMonth() - 1)
		if (time === "4")
			newDate.setFullYear(newDate.getFullYear() - 1);

		var fromDateString = ('0' + newDate.getDate()).slice(-2) + '-'
			+ month_names_short[MyDate.getMonth()] + '-'
			+ newDate.getFullYear();
		if (time != 1) {
			this.reportDate = "From " + fromDateString + " to " + toDateString;
			$('.report_period').css("padding-left", "");
		}
		else {
			this.reportDate = "Today";
			$('.report_period').css("padding-left", 200 + "px");
		}
	}

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/transaction-report/transaction-report.component.ts